class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-items').updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name')
    );
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    const eventData = JSON.parse(
      this.querySelector(`cart-remove-button[data-index="${line}"] > script`).innerHTML
    );

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.json();
      })
      .then((state) => {
        const parsedState = state;
        const cartUpdateEvent = new CustomEvent('cartUpdate', {
          detail: parsedState,
        });
        document.dispatchEvent(cartUpdateEvent);
        this.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) ||
            document.getElementById(section.id);

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          lineItem.querySelector(`[name="${name}"]`).focus();
        }

        if (window.FarmRio.events.removeFromCart) {
          let items = Array.isArray(eventData) ? eventData : [eventData];

          items = items.map((item) => {
            item.price = item.price / 100;
            item.salesPrice = item.salesPrice / 100;
            return item;
          });

          const eventName = window.FarmRio.events.removeFromCart;
          const event = new CustomEvent(eventName, { detail: items });
          document.dispatchEvent(event);
        }

        document.dispatchEvent(
          new CustomEvent('cartChanged', {
            detail: { source: 'cart-page' },
          })
        );

        this.disableLoading();
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay--price').forEach((overlay) =>
          overlay.classList.add('hidden')
        );
        this.querySelectorAll('.cart-item__price-content span').forEach(
          (span) => (span.style.visibility = 'visible')
        );
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document
        .getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text').innerHTML =
        window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    document.getElementById('main-cart-items').classList.add('cart__items--disabled');
    this.querySelectorAll(`#CartItem-${line} .cart-item__price-content span`).forEach(
      (span) => (span.style.visibility = 'hidden')
    );
    this.querySelectorAll(`#CartItem-${line} .loading-overlay--price`).forEach((overlay) =>
      overlay.classList.remove('hidden')
    );
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
    this.querySelectorAll('.loading-overlay--price').forEach((overlay) =>
      overlay.classList.add('hidden')
    );
    this.querySelectorAll('.cart-item__price-content span').forEach(
      (span) => (span.style.visibility = 'visible')
    );
  }
}

customElements.define('cart-items', CartItems);

// Cart/Wishlist Tab Functionality
document.addEventListener('DOMContentLoaded', function () {
  // Detect wishlist mode from URL
  function isWishlistMode() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.has('wishlist') || window.location.search.includes('wishlist');
  }

  // Show/hide content based on mode
  function switchTabContent(showWishlist) {
    const cartContent = document.getElementById('cart-content');
    const wishlistContent = document.getElementById('wishlist-content');

    if (showWishlist) {
      // Force wishlist display, overriding any server-side CSS
      cartContent.style.display = 'none';
      cartContent.style.setProperty('display', 'none', 'important');

      wishlistContent.style.display = 'block';
      wishlistContent.style.setProperty('display', 'block', 'important');

      // Force a reflow to ensure opacity transition works
      setTimeout(() => {
        wishlistContent.style.opacity = '1';
        wishlistContent.style.setProperty('opacity', '1', 'important');
        // Update counter when wishlist content is shown
        updateWishlistCounter();
      }, 10);
    } else {
      // Switching to Bag tab - check if refresh is needed
      if (bagNeedsRefresh) {
        refreshCartSections(false); // false = not silent, allow tab changes
        bagNeedsRefresh = false;
      }

      cartContent.style.display = 'block';
      cartContent.style.setProperty('display', 'block', 'important');

      wishlistContent.style.display = 'none';
      wishlistContent.style.setProperty('display', 'none', 'important');
      wishlistContent.style.opacity = '0';
    }
  }

  // Update tab active states
  function updateTabStates(showWishlist) {
    // Use IDs for reliable element selection
    const bagTab = document.getElementById('bag-tab');
    const wishlistTab = document.getElementById('wishlist-tab');

    // Bag tab: active (black) when NOT wishlist mode
    if (bagTab) {
      if (!showWishlist) {
        bagTab.classList.add('tw-text-black');
        bagTab.classList.remove('tw-text-gray-600');
      } else {
        bagTab.classList.remove('tw-text-black');
        bagTab.classList.add('tw-text-gray-600');
      }
    }

    // Wishlist tab: active (black) when wishlist mode
    if (wishlistTab) {
      if (showWishlist) {
        wishlistTab.classList.add('tw-text-black');
        wishlistTab.classList.remove('tw-text-gray-600');
      } else {
        wishlistTab.classList.remove('tw-text-black');
        wishlistTab.classList.add('tw-text-gray-600');
      }
    }
  }

  // Check if user is logged in by checking farmrio_at cookie
  function isUserLoggedIn() {
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
      const [name, value] = cookie.trim().split('=');
      if (name === 'farmrio_at' && value && value !== '') {
        return true;
      }
    }
    return false;
  }

  // Get wishlist count from various sources
  function getWishlistCount() {
    let count = 0;

    // Check if user is logged in
    const userIsLoggedIn = isUserLoggedIn();

    if (userIsLoggedIn) {
      // For logged-in users, prioritize DOM count (most accurate)
      const wishlistItems = document.querySelectorAll('.wishlist-product-item');
      if (wishlistItems.length > 0) {
        return wishlistItems.length;
      }

      // Fallback: Get from server-side rendered counter
      const serverCounters = document.querySelectorAll('[data-wishlist-count]');
      for (const counter of serverCounters) {
        const serverCount = parseInt(counter.getAttribute('data-wishlist-count'));
        if (!isNaN(serverCount) && serverCount >= 0) {
          return serverCount;
        }
      }

      // Additional fallback: Extract from wishlist tab text
      const wishlistTab = document.querySelector('#wishlist-tab');
      if (wishlistTab) {
        const match = wishlistTab.textContent.match(/Wishlist\s*\((\d+)\)/);
        if (match) {
          return parseInt(match[1]);
        }
      }
    } else {
      // For logged-out users, use localStorage
      if (window.Wishlist) {
        count = window.Wishlist.getWishlistCountFromLocalStorage() || 0;
        return count;
      }
    }

    // Final fallback: Get from wishlist content span
    const wishlistCountSpans = document.querySelectorAll('.tw-text-lg.tw-text-gray-600');
    for (const span of wishlistCountSpans) {
      const match = span.textContent.match(/(\d+)\s+(product|item)/);
      if (match) {
        return parseInt(match[1]);
      }
    }

    return 0;
  }

  // Update wishlist counter when wishlist items change
  function updateWishlistCounter() {
    const wishlistTab = document.querySelector('#wishlist-tab span[data-wishlist-count]');
    if (wishlistTab) {
      const wishlistCount = getWishlistCount();
      wishlistTab.textContent = `Wishlist (${wishlistCount})`;
      wishlistTab.setAttribute('data-wishlist-count', wishlistCount);

      // Also update the Wishlist service counter for consistency
      if (window.Wishlist && window.Wishlist.updateWishlistCounter) {
        window.Wishlist.updateWishlistCounter();
      }
    }
  }

  // Function to refresh cart content sections
  // silent = true: Updates cart content in background without changing current tab (stays on wishlist)
  // silent = false: Updates cart content with full logging (for debugging)
  function refreshCartSections(silent = true) {
    const sectionsToRender = [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items')?.dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];

    // Build sections query
    const sections = sectionsToRender.map((section) => section.section).filter(Boolean);

    if (sections.length === 0) {
      return;
    }

    // Fetch updated cart sections
    const sectionsParam = sections.join(',');
    const url = `${window.routes?.cart_url || '/cart'}?sections=${sectionsParam}`;

    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        sectionsToRender.forEach((section) => {
          if (data[section.section]) {
            const elementToReplace =
              document.getElementById(section.id)?.querySelector(section.selector) ||
              document.getElementById(section.id);
            if (elementToReplace) {
              const parser = new DOMParser();
              const newContent = parser.parseFromString(data[section.section], 'text/html');
              const newSection =
                newContent.querySelector(section.selector) || newContent.body.firstChild;
              if (newSection) {
                elementToReplace.innerHTML = newSection.innerHTML;
              }
            }
          }
        });

        // Dispatch cart update event after sections are refreshed
        document.dispatchEvent(
          new CustomEvent('cartSectionsRefreshed', {
            detail: { silent: silent },
          })
        );
      })
      .catch((error) => {
        console.error('Error refreshing cart sections:', error);
      });
  }

  // Update cart counter when cart changes
  function updateCartCounter() {
    const cartTab = document.getElementById('bag-tab');
    if (!cartTab) {
      return;
    }

    // Try multiple methods to get accurate cart count
    let cartCount = 0;

    // Method 1: Get from window.Cart if available (most up-to-date)
    if (window.Cart && window.Cart.state && typeof window.Cart.state.item_count === 'number') {
      cartCount = window.Cart.state.item_count;
      cartTab.textContent = `Bag (${cartCount})`;
      return;
    }

    // Method 2: Get from cart-json script tag
    const cartData = document.querySelector('#cart-json');
    if (cartData) {
      try {
        const cart = JSON.parse(cartData.textContent);
        cartCount = cart.item_count || 0;
        cartTab.textContent = `Bag (${cartCount})`;
        return;
      } catch (e) {
        console.warn('Error parsing cart JSON:', e);
      }
    }

    // Method 3: Count cart items from DOM (fallback)
    const cartItems = document.querySelectorAll('.cart-item');
    cartCount = cartItems.length;
    cartTab.textContent = `Bag (${cartCount})`;

    // Method 4: If all else fails, fetch current cart state
    if (cartCount === 0) {
      fetch('/cart.js')
        .then((response) => response.json())
        .then((cart) => {
          cartTab.textContent = `Bag (${cart.item_count || 0})`;
        })
        .catch((error) => {
          console.warn('Error fetching cart state:', error);
        });
    }
  }

  // Handle tab clicks
  const tabs = document.querySelectorAll('#bag-tab, #wishlist-tab');
  tabs.forEach((tab) => {
    tab.addEventListener('click', function (e) {
      e.preventDefault();
      const isWishlistTab = this.id === 'wishlist-tab';

      // Update URL without reloading
      const newUrl = isWishlistTab ? '/cart?wishlist' : '/cart';
      window.history.pushState({}, '', newUrl);

      // Switch content
      switchTabContent(isWishlistTab);
      updateTabStates(isWishlistTab);

      // Force counter update after tab switch
      setTimeout(function () {
        updateWishlistCounter();
        updateCartCounter();
      }, 50);
    });
  });

  // Listen for wishlist events
  if (window.FarmRio && window.FarmRio.events) {
    document.addEventListener(window.FarmRio.events.wishlistItemAdded, function (e) {
      updateWishlistCounter();
    });

    document.addEventListener(window.FarmRio.events.wishlistItemRemoved, function (e) {
      updateWishlistCounter();
    });

    document.addEventListener(window.FarmRio.events.cartUpdate, function (e) {
      // Check if we're in wishlist mode by URL parameter
      const urlParams = new URLSearchParams(window.location.search);
      const isWishlistMode = urlParams.has('wishlist');

      if (isWishlistMode) {
        // Only update counter for wishlist actions
        updateCartCounter();
        bagNeedsRefresh = true;

        // Ensure we stay on wishlist tab and prevent any page redirects
        if (!urlParams.has('wishlist')) {
          // If we're not already in wishlist mode, update URL without reload
          const newUrl = window.location.pathname + '?wishlist';
          window.history.pushState({}, '', newUrl);
          switchTabContent(true);
          updateTabStates(true);
        }
      } else {
        // For other sources, update normally
        updateCartCounter();
        refreshCartSections(true);
      }
    });

    // Listen for add to cart events (including from wishlist)
    document.addEventListener(window.FarmRio.events.addToCart, function (e) {
      // Check if we're in wishlist mode by URL parameter
      const urlParams = new URLSearchParams(window.location.search);
      const isWishlistMode = urlParams.has('wishlist');

      if (isWishlistMode) {
        // Only update counter for wishlist actions
        updateCartCounter();
        bagNeedsRefresh = true;

        // Ensure we stay on wishlist tab and prevent any page redirects
        if (!urlParams.has('wishlist')) {
          // If we're not already in wishlist mode, update URL without reload
          const newUrl = window.location.pathname + '?wishlist';
          window.history.pushState({}, '', newUrl);
          switchTabContent(true);
          updateTabStates(true);
        }
      } else {
        // For other sources, update normally
        updateCartCounter();
        refreshCartSections(true);
      }
    });
  }

  // Listen for custom wishlist events from my-wishlist.liquid
  document.addEventListener('wishlistItemRemoved', function (e) {
    // If we have the remaining count from the event, use it for more accurate counting
    if (e.detail && typeof e.detail.remaining_count === 'number') {
      const wishlistTab = document.querySelector('#wishlist-tab span[data-wishlist-count]');
      if (wishlistTab) {
        wishlistTab.textContent = `Wishlist (${e.detail.remaining_count})`;
        wishlistTab.setAttribute('data-wishlist-count', e.detail.remaining_count);
      }
    } else {
      // Fallback to recalculating the count
      updateWishlistCounter();
    }
  });

  // Flag to track if bag content needs refresh
  let bagNeedsRefresh = false;

  // Listen for general cart changes (including from wishlist)
  document.addEventListener('cartChanged', function (e) {
    // Check if we're in wishlist mode by URL parameter
    const urlParams = new URLSearchParams(window.location.search);
    const isWishlistMode = urlParams.has('wishlist');

    if (isWishlistMode) {
      // Only update counter, don't refresh bag content
      updateCartCounter();
      bagNeedsRefresh = true;

      // Ensure we stay on wishlist tab and prevent any page redirects
      if (!urlParams.has('wishlist')) {
        // If we're not already in wishlist mode, update URL without reload
        const newUrl = window.location.pathname + '?wishlist';
        window.history.pushState({}, '', newUrl);
        switchTabContent(true);
        updateTabStates(true);
      }
    } else {
      // For other sources, update normally
      updateCartCounter();
      refreshCartSections(true);
    }
  });

  // Observer to watch for changes in wishlist content
  const wishlistContent = document.getElementById('wishlist-content');
  if (wishlistContent) {
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList') {
          updateWishlistCounter();
        }
      });
    });

    observer.observe(wishlistContent, {
      childList: true,
      subtree: true,
    });
  }

  // Handle browser back/forward buttons
  window.addEventListener('popstate', function (e) {
    const showWishlist = isWishlistMode();
    switchTabContent(showWishlist);
    updateTabStates(showWishlist);
  });

  const showWishlist = isWishlistMode();

  switchTabContent(showWishlist);
  updateTabStates(showWishlist);

  updateWishlistCounter();
  updateCartCounter();

  // Update counters after a delay to ensure all elements are loaded
  setTimeout(function () {
    updateWishlistCounter();
    updateCartCounter();
  }, 100);

  // Update counters periodically to ensure they're always accurate
  setInterval(function () {
    updateWishlistCounter();
    updateCartCounter();
  }, 3000);
});

if (window.FarmRio.events.viewCart) {
  document.dispatchEvent(new CustomEvent(window.FarmRio.events.viewCart));
}
